const initialState = {
  sites: [],
};

export const hierarchyReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_COUNTRY_SITES':
      return {
        ...state,
        sites: [...action.payload],
      };
    case 'SET_COUNTRY_SITES_ERROR':
      return state;
    default:
      return state;
  }
};
